const product = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default product;
